import { rem } from 'polished';
import styled from 'styled-components';
import { IconTemplate } from '@components/Icon/IconTemplate';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin: ${rem(0)} 0 ${rem(45)} 0;
    padding: ${rem(30)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    @media (min-width: ${breakpoints.md}px) {
        padding: 0;
    }
`;

export const Sections = styled.div`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    display: flex;
    flex-direction: column;

   
`;

export const Section = styled.div<{ isMission?: boolean }>`
    margin-bottom: ${rem(10)};
`;

export const SectionHeader = styled.div<{ isMission?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-family: ${({ theme }) => theme.fonts.fontSecondary};

    svg {
        margin-right: ${rem(14)};
        width: ${rem(20)};
        height: ${rem(20)};

        path {
            fill: ${({ theme }) => theme.colors.primary};
        }
    }
`;

export const SectionDescription = styled.div`
    padding-top: ${rem(0)};
    padding-bottom: ${rem(20)};

    color: ${({ theme }) => theme.colors.grey};
    line-height: ${rem(30)};
    strong {
        color: black;
    }
`;

export const TransportationOption = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    padding-bottom: ${rem(10)};
`;

export const TransportationHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: ${rem(30)} 0;
    
    cursor: pointer;
`;

export const TransportationHeaderTexts = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const TransportationHeaderTitle = styled.div`
    font-size: ${rem(18)};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary};
    &.isOpen {
        color: ${({ theme }) => theme.colors.primary};
    }
`;



export const TransportationHeaderDesc = styled.div`
    font-size: ${rem(14)};
    line-height: ${rem(22)};
    padding-right: ${rem(0)};
    @media (min-width: ${breakpoints.sm}px) {
        padding-right: ${rem(100)};
    }
`;

export const TransportationHeaderRights = styled.div`
    padding-right: ${rem(20)};
    gap: ${rem(20)};
    display: flex;
    align-items: center;
`;

export const TransportationHeaderBanner = styled.div`
    font-size: ${rem(14)};
    font-weight: 600;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.primary};
    padding: ${rem(5)} ${rem(20)}
`;

export const TransportationHeaderIcon = styled(IconTemplate)`
    svg {
        width: ${rem(20)};
        height: ${rem(20)};
    }

    &.isOpen {
        svg {
            transform: rotate(180deg);
        }
    }
`;

export const TransportationDescription = styled.div`
    padding: ${rem(20)} 0;
    line-height: ${rem(24)};
    padding-left: ${rem(10)};
    font-size: ${rem(16)};
    .withBorder {
        text-decoration: underline;
        display: block;
        padding: ${rem(20)} 0;
    }
  
    .question {
        text-decoration: underline;
    }

    ul {
        padding-top: ${rem(20)};
        padding-bottom: ${rem(8)};
    }

    ol {
        padding-bottom: ${rem(8)};
    }

    li {
        margin: ${rem(5)} 0;
        padding-bottom: ${rem(10)};
    }

    a {
        color: ${({ theme }) => theme.colors.primary};
        text-decoration: underline;
    }

    @media (min-width: ${breakpoints.sm}px) {
        padding-left: ${rem(100)};
    }
   
`;

export const Link = styled.a`
    
`;
